import {
  BUILDING_RESIDENTS_REQUESTED,
  BUILDING_STAFF_REQUESTED,
  GET_BUILDING_RESIDENTS_SUCCESS,
  GET_BUILDING_STAFF_SUCCESS,
  GET_PMC_STAFF_SUCCESS,
  PMC_STAFF_REQUESTED,
} from '../actionConstants';

import { arrayToObject } from './utils';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case BUILDING_RESIDENTS_REQUESTED:
    case BUILDING_STAFF_REQUESTED:
    case PMC_STAFF_REQUESTED: {
      return {
        ...arrayToObject(action?.payload?.data),
      };
    }
    case GET_PMC_STAFF_SUCCESS:
    case GET_BUILDING_RESIDENTS_SUCCESS:
    case GET_BUILDING_STAFF_SUCCESS: {
      return {
        ...action.res.data,
      };
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
